import React from "react";
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Header.scss";

const Navbar = ({ isMenuOpen = false, setIsMenuOpen = () => { }, closeMenu = () => { } }) => {
    const handleClose = () => {
        closeMenu();
        setIsMenuOpen(false);
    };
    return (
        <nav
            id="main-navigation"
            className={`navigationMenu ${isMenuOpen ? "open" : ""}`}
            aria-label="Primary"
            onClick={handleClose}
        >
            <ul>
                <li>
                    <NavLink to="/" onClick={handleClose}>
                        Home
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/projects" onClick={handleClose}>
                        Projects
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/contact" onClick={handleClose}>
                        Contact
                    </NavLink>
                </li>
                <li>
                    <div className="contact-actions">
                        <a
                            href="https://www.linkedin.com/in/kayleighschlupp/"
                            className="btn btn-icon"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Open LinkedIn (opens in a new tab)"
                        >
                            <FontAwesomeIcon icon={['fab', 'linkedin-in']} />
                            {/* <span className="label">LinkedIn</span> */}
                        </a>

                        <a
                            href="https://github.com/kkowatsch"
                            className="btn btn-icon"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Open GitHub (opens in a new tab)"
                        >
                            <FontAwesomeIcon icon={['fab', 'github']} />
                            {/* <span className="label">GitHub</span> */}
                        </a>
                    </div>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;